import { useCallback, useEffect } from "react";
import { reactivationFlowKey } from "utils/constants";
import { useSelector, useDispatch } from "react-redux";
import { UPDATE_REACTIVATION_FLOW } from "utils/action-types";

const isReactivationFlowActive = (flow) =>
	(flow.step > 0 && !flow.isCompleted) || flow.step === 4;

const useReactivationFlow = () => {
	const { reactivationFlow } = useSelector(state => state.account.subscription);
	const dispatch = useDispatch();

	useEffect(() => {
		const flowStorage = JSON.parse(sessionStorage.getItem(reactivationFlowKey));
		if (flowStorage) {
			dispatch({
				type: UPDATE_REACTIVATION_FLOW, payload:
					{ ...flowStorage, isActive: isReactivationFlowActive(flowStorage) }
			});
		}
	}, []);

	const updateReactivationFlow = useCallback((newState) => {
		const updatedState = { ...reactivationFlow, ...newState };
		updatedState.isActive = isReactivationFlowActive(updatedState);

		dispatch({ type: UPDATE_REACTIVATION_FLOW, payload: updatedState });
		sessionStorage.setItem(reactivationFlowKey, JSON.stringify(updatedState));
	}, [reactivationFlow]);

	const resetReactivationFlow = () => {
		sessionStorage.removeItem(reactivationFlowKey);
		dispatch({ type: UPDATE_REACTIVATION_FLOW, payload: { step: null, isActive: false, isCompleted: false, mealsConfirmed: false } });
	};

	return { reactivationFlow: reactivationFlow, updateReactivationFlow, resetReactivationFlow };
};
export default useReactivationFlow;